import {FC, RefObject} from 'react'
import {NoResults} from 'features/noResults'
import styles from './styles.module.scss'

type PayFrameProps = {
  maxPayRef: RefObject<HTMLDivElement>
  iframeId: string
  isError: boolean
}

export const PayFrame: FC<PayFrameProps> = ({maxPayRef, iframeId, isError})=>{
  if (isError) return <NoResults className={styles.frameError} header='Failed to load this page' text='Try again or contacts support' />

  return (
    <div className={styles.container} ref={maxPayRef} >
      <form className='pspPaymentForm' />
      <iframe style={{maxWidth: 'none'}} id={iframeId} />
    </div>
  )
}